import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Card, CardBody, Col } from "reactstrap";
import { ZeroConfigurationTitle } from "../../../../../constants";
import { ZeroConfigItems } from "../../../../../types/Tables";
import FilterComponent from "../common/FilterComponent";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";
import { ZeroConfigurationSubTitle, ZeroConfigurationTableColumns, ZeroConfigurationTableData } from "../../../../../data/formsAndTable/tables/dataTables/BasicInit";

const ZeroConfigurationTable = () => {
  const [filterText, setFilterText] = useState("");
  const filteredItems: ZeroConfigItems[] = ZeroConfigurationTableData.filter((item: ZeroConfigItems) => Object.values(item).some((value) => value && value.toString().toLowerCase().includes(filterText.toLowerCase())));
  return (
    <Col sm="12">
      <Card className="custom-configuration">
        <CommonCardHeader headClass="card-no-border" tag title={ZeroConfigurationTitle} span={ZeroConfigurationSubTitle} />
        <CardBody>
          <FilterComponent onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} filterText={filterText} />
          <div className="table-responsive">
            <DataTable className="custom-scrollbar" data={filteredItems} columns={ZeroConfigurationTableColumns} pagination highlightOnHover striped />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ZeroConfigurationTable;
